export const MANUAL_DOC_ENDPOINTS = {
  PURCHASE_ORDER: "/createPurchaseOrder",
  DELIVERY_NOTE: "/createDeliveryNote",
  INVOICE: "/createInvoice",
  SDI_REGULAR_INVOICE: "/createSDIRegularInvoice",
  SDI_CREDIT_NOTE: "/createSDICreditNote",
  SII_REGULAR_INVOICE: "/CreateSIIRegularInvoice",
  SII_SIMPLIFIED_INVOICE: "/createSIISimplifiedInvoice",
  SII_REPLACEMENT_INVOICE: "/CreateSIIReplacementInvoice",
  SII_CORRECTIVE_ON_REGULAR: "/CreateSIICorrectiveInvoiceOnRegularInvoice",
  SII_CORRECTIVE_ON_SIMPLIFIED_R5:
    "/CreateSIICorrectiveInvoiceOnSimplifiedInvoiceByR5",
  SII_CREDIT_NOTE_ON_REGULAR: "/CreateSIICreditNoteOnRegularInvoice",
  SII_CREDIT_NOTE_ON_SIMPLIFIED_R5:
    "/CreateSIICreditNoteOnSimplifiedInvoiceByR5",
  VERIFACTU_REGULAR_INVOICE: "/createVerifactuRegularInvoice",
  VERIFACTU_SIMPLIFIED_INVOICE: "/createVerifactuSimplifiedInvoice",
  VERIFACTU_CORRECTIVE_INVOICE: "/createVerifactuCorrectiveInvoice",
  VERIFACTU_CREDIT_NOTE: "/createVerifactuCreditNote",
  VERIFACTU_DEBIT_NOTE: "/createVerifactuDebitNote",
  FRANCE_REGULAR_INVOICE: "/createFrancePARegularInvoice",
} as const;

export type TManualDocEndpointKey = keyof typeof MANUAL_DOC_ENDPOINTS;

export const branchByInvoiceType =
  (regularEndpoint: string, simplifiedEndpoint: string) =>
  (ctx: { invoiceType: string }) =>
    ctx.invoiceType === "simplified" ? simplifiedEndpoint : regularEndpoint;
